import AddCampusesConfirmModal from "./AddCampusesConfirmModal";
export default AddCampusesConfirmModal;
